import React from "react";
import { SportsTable } from "../helper/interfaces";
import Image from 'next/image';
import { SportsTickerEventType } from "../helper/enums";
import { MatchState } from "../helper/enums";

export default function TickerTable(data: {sportsTable: SportsTable}) {
  const sportstable = data.sportsTable;
  
  return (
    <React.Fragment>
      <div className="">
          <div className="kick__ticker ticker__row kick__card kick__ressort-headline kick__site-padding kick__matches">
            <div className="ticker__header">
              <div className="ticker__header__wrapper">
                <h2 className="modul__teaser__headline">{sportstable.headline}</h2>
              </div>
            </div>
          </div>
          <div className="kick__modul__item">
            <table className="kick__table kick__table--ranking kick__table--alternate kick__table--resptabelle">
              <thead>
                <tr>
                  <th className="kick__respt-m-o-1 kick__respt-m-w-50">
                    <div className="kick__table-sort kick__table-sort_center">Platz</div>
                  </th>
                  {/*<th className="kick__table--ranking__rank kick__t__a__l kick__respt-m-o-2 kick__respt-m-w-0">
                    <div className="kick__table-sort"></div>
                  </th>
                  <th></th>*/}
                  <th className="kick__t__a__l kick__table--ranking__index kick__respt-m-o-4 kick__respt-m-w-120 kick__t__a__l">
                    <div className="kick__table-sort"></div>
                  </th>
                  <th className="kick__respt-m-o-3 kick__respt-m-w-40 kick__t__a__l">
                    <div className="kick__table-sort">Team</div>
                  </th>
                  <th>
                    <div className="kick__table-sort">
                      Spiele
                    </div>
                  </th>
                  <th>
                    <div className="kick__table-sort">
                      Diff.
                    </div>
                  </th>
                  <th>
                    <div className="kick__table-sort">
                      Pkt.
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody id="table">
                <tr></tr>
                {sportstable.entries.map((entry) =>
                  <tr key={entry.position}>
                    <td className="kick__table--ranking__rank kick__respt-m-o-1 kick__respt-m-w-40">{entry.position}</td>
                    {/*<td className=""></td>*/}
                    <td className="kick__table--ranking__teamicon kick__respt-m-o-3 kick__respt-m-w-40 kick__table--img">
                      <Image src={entry.team.icon} alt="Logo" width="30" height="30" className="" />
                    </td>
                    {/*<td></td>*/}
                    <td className="kick__table--ranking__teamname kick__table--ranking__index kick__t__a__l kick__respt-m-o-4 kick__respt-m-w-120 kick__t__a__l">
                      <span className="kick__table--show-mobile">{entry.team.name}</span>
                    </td>
                    <td className="kick__table--ranking__number text-right">
                      {entry.matches}
                    </td>
                    <td className="kick__table--ranking__number text-right">
                      {entry.goalDifference}
                    </td>
                    <td className="kick__table--ranking__master kick__respt-m-o-5 text-right">
                      {entry.points}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          
      </div>
    </React.Fragment>
  );
}
